export const createMinMaxTime = (minOrMaxHour: number, start: Date): Date =>
  new Date(start.getFullYear(), start.getMonth(), start.getDate(), minOrMaxHour);
export const createMinTime = (minHour: number, start: Date): Date =>
  new Date(start.getFullYear(), start.getMonth(), start.getDate(), minHour, 0, 0, 0);
export const createMaxTime = (maxHour: number, start: Date): Date =>
  new Date(start.getFullYear(), start.getMonth(), start.getDate(), maxHour, 59, 59, 999 ) ;


// WEBPACK FOOTER //
// ./src/calendar/calendar.util.tsx